<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AllowedUserAuthContainer',
  props: {
    pageTypes: {
      type: Array,
      required: true,
      validator: (values) => {
        return values.filter(value => ['admin', 'writer', 'client', 'manager'].indexOf(value) !== -1).length > 0
      }
    }
  },
  data () {
    return {
      fetched: false
    }
  },
  computed: {
    ...mapState({
      authUser: (state) => state.UserAuthStore.currentUserAuth
    })
  },
  async mounted () {
    if (!this.fetched) {
      await this.$store
        .dispatch('UserAuthStore/fetchCurrentUserAuth')
        .then(() => {
          this.fetched = true
        })
    }
    if (!this.permittedMasterAccess()) {
      return this.$store.commit('errorPage/setForbidden', true)
    }
    this.$store.dispatch('I18n/fetchI18nTranslation')
  },
  methods: {
    permittedMasterAccess () {
      return this.pageTypes.includes(this.authUser.masterAccess)
    }
  }
}
</script>
